import { animate, style, transition, trigger } from '@angular/animations';
import {
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { ThemeManagerService } from '~/services/theme-manager';
import { SliderTemplateDirective } from './template';

@Component({
    selector: 'asap-slider',
    templateUrl: './slider.html',
    styleUrls: ['./slider.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('sliderAnimation', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('500ms', style({ opacity: 1 })),
            ]),
        ]),
    ],
    host: {
        class: 'asap-slider',
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SliderComponent<T> implements OnInit, AfterContentInit {
  _templates: any[];
  _tempToShow: any;
  _sliderIndex: number = 0;
  _showPrevIcon: boolean;
  _showNextIcon: boolean;
  _theme: string;

  @Input() prevIcon: string;
  @Input() nextIcon: string;
  @Input() shownNumber: number;

  @Output() getTemplateName: EventEmitter<string> = new EventEmitter();
  @Output() getAllTemplatesNames: EventEmitter<string[]> = new EventEmitter();

  @ContentChildren(SliderTemplateDirective) templates: QueryList<
    SliderTemplateDirective<T>
  >;

  constructor(
    private _themeManager: ThemeManagerService,
  ) {
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
  }

  ngOnInit() { }

  ngAfterContentInit() {
    this._templates = this.templates.toArray();
    let allTemplatesNames: string[] = [];
    this._templates.forEach((x) => {
      allTemplatesNames.push(x.template._declarationTContainer.attrs[1]);
    });
    this.getAllTemplatesNames.emit(allTemplatesNames);

    this.initData();
  }

  private initData() {
    this._showPrevIcon = this._sliderIndex > 0;
    this._showNextIcon = this.shownNumber + this._sliderIndex <= this._templates.length - 1;

    this._tempToShow = this._templates.slice(
      this._sliderIndex,
      this.shownNumber + this._sliderIndex
    );

    this.getTemplateName.emit(this._tempToShow[0].template._declarationTContainer.attrs[1])
  }

  _onPrev() {
    if (this._sliderIndex > 0) {
      this._sliderIndex = this._sliderIndex - this.shownNumber;
      this.initData();
    }
  }

  _onNext() {
    if (this.shownNumber + this._sliderIndex <= this._templates.length - 1) {
      this._sliderIndex = this._sliderIndex + this.shownNumber;
      this.initData();
    }
  }
}
